import React, { lazy } from 'react';
import { Clock, CheckCircle2, Lock, ShieldCheck, CreditCard, Star } from 'lucide-react';
import { Countdown } from './Countdown';
const IMG_RECETARIO = 'https://cdn.magicpatterns.com/uploads/cCEEGmoLnawrgKmm7fpLEG/PORTADA_RECETARIO_BUDINES.jpg';
const IMG_BONO_1 = 'https://cdn.magicpatterns.com/uploads/juiUaShqgxjJgCLuuuEQU7/BONO_1_EMPRENDER.jpg';
const IMG_BONO_2 = 'https://cdn.magicpatterns.com/uploads/dtj7Ncvbp3EfJJApgyx8ef/BONO_2_CONSERVACION.jpg';
const IMG_BONO_3 = 'https://cdn.magicpatterns.com/uploads/oDpiJdc3skG91BUSiiAEfJ/BONO_3_SUSTITUCIONES.jpg';
export function OfferSection() {
  const checkoutUrl = 'https://pay.hotmart.com/X104283580R?checkoutMode=10';
  return <>
      {/* 10. Sección de Urgencia */}
      <section className="bg-red-50 border-y border-red-100 py-8 px-4" data-id="element-68">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-69">
          <div className="flex items-center gap-3" data-id="element-70">
            <Clock className="w-8 h-8 text-red-600 animate-pulse" data-id="element-71" />
            <h2 className="text-2xl font-bold text-red-600" data-id="element-72">
              ¡Apurate! La oferta termina pronto
            </h2>
          </div>
          <Countdown variant="red" data-id="element-73" />
        </div>
      </section>

      {/* 11. Sección de Oferta */}
      <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-[#FAF6F0] to-white scroll-mt-20" data-id="element-74">
        <div className="max-w-4xl mx-auto" data-id="element-75">
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden" data-id="element-76">
            <div className="bg-green-500 text-white text-center py-4" data-id="element-77">
              <h2 className="text-2xl md:text-3xl font-bold" data-id="element-78">
                Accedé Ahora al Mega-Pack
              </h2>
            </div>

            <div className="p-8 md:p-12" data-id="element-79">
              <div className="flex flex-col md:flex-row gap-10 items-center mb-10" data-id="element-80">
                {/* Mini Pack Image */}
                <div className="w-full md:w-1/3 relative h-56" data-id="element-81">
                  <img src={IMG_BONO_1} alt="Bono" className="absolute w-[40%] left-0 top-[10%] -rotate-12 rounded shadow-md border-2 border-white object-cover aspect-[3/4]" data-id="element-82" />
                  <img src={IMG_BONO_2} alt="Bono" className="absolute w-[40%] right-[10%] top-[5%] rotate-12 rounded shadow-md border-2 border-white object-cover aspect-[3/4]" data-id="element-83" />
                  <img src={IMG_BONO_3} alt="Bono" className="absolute w-[40%] right-0 top-[20%] rotate-[24deg] rounded shadow-md border-2 border-white object-cover aspect-[3/4]" data-id="element-84" />
                  <img src={IMG_RECETARIO} alt="Main" className="absolute w-[55%] left-[50%] -translate-x-[50%] top-0 z-10 rounded-lg shadow-xl border-2 border-white object-cover aspect-[3/4]" data-id="element-85" />
                </div>

                {/* List */}
                <div className="w-full md:w-2/3 space-y-4" data-id="element-86">
                  <div className="flex items-center justify-between border-b border-stone-100 pb-2" data-id="element-87">
                    <div className="flex items-center gap-2" data-id="element-88">
                      <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-89" />
                      <span className="font-medium text-stone-800" data-id="element-90">
                        20 Budines Irresistibles
                      </span>
                    </div>
                    <span className="text-stone-500" data-id="element-91">USD 39</span>
                  </div>
                  <div className="flex items-center justify-between border-b border-stone-100 pb-2" data-id="element-92">
                    <div className="flex items-center gap-2" data-id="element-93">
                      <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-94" />
                      <span className="font-medium text-stone-800" data-id="element-95">
                        Bono 1: Emprendé
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-96">
                      <span className="text-stone-400 line-through text-sm" data-id="element-97">
                        USD 19
                      </span>
                      <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-0.5 rounded" data-id="element-98">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between border-b border-stone-100 pb-2" data-id="element-99">
                    <div className="flex items-center gap-2" data-id="element-100">
                      <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-101" />
                      <span className="font-medium text-stone-800" data-id="element-102">
                        Bono 2: Conservá
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-103">
                      <span className="text-stone-400 line-through text-sm" data-id="element-104">
                        USD 14
                      </span>
                      <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-0.5 rounded" data-id="element-105">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between border-b border-stone-100 pb-2" data-id="element-106">
                    <div className="flex items-center gap-2" data-id="element-107">
                      <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-108" />
                      <span className="font-medium text-stone-800" data-id="element-109">
                        Bono 3: Sustituí
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-110">
                      <span className="text-stone-400 line-through text-sm" data-id="element-111">
                        USD 12
                      </span>
                      <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-0.5 rounded" data-id="element-112">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pricing */}
              <div className="text-center mb-8" data-id="element-113">
                <p className="text-stone-500 mb-2" data-id="element-114">
                  Valor total: <span className="line-through" data-id="element-115">USD 84</span>
                </p>
                <p className="text-stone-500 mb-1" data-id="element-116">
                  Precio normal:{' '}
                  <span className="line-through decoration-red-500 decoration-2" data-id="element-117">
                    USD 39
                  </span>
                </p>
                <div className="flex items-center justify-center gap-4 mt-3" data-id="element-118">
                  <div className="text-5xl md:text-6xl font-extrabold text-violet-900" data-id="element-119">
                    <span className="text-3xl text-stone-500 font-bold align-top" data-id="element-120">
                      USD
                    </span>{' '}
                    17
                  </div>
                  <div className="bg-green-100 text-green-700 font-bold px-3 py-1 rounded-lg text-lg" data-id="element-121">
                    Ahorrás 80%
                  </div>
                </div>
              </div>

              <div className="flex justify-center mb-8" data-id="element-122">
                <Countdown variant="light" data-id="element-123" />
              </div>

              {/* CTA */}
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-600 text-white text-center text-2xl font-bold py-6 rounded-2xl shadow-[0_10px_30px_rgba(34,197,94,0.4)] hover:shadow-[0_15px_40px_rgba(34,197,94,0.6)] transition-all animate-pulse mb-6" data-id="element-124">
                COMPRAR AHORA
              </a>

              {/* Payment Badges */}
              <div className="flex justify-center gap-3 mb-10 flex-wrap" data-id="element-125">
                <div className="w-12 h-8 bg-blue-900 rounded flex items-center justify-center text-white text-xs font-bold italic" data-id="element-126">
                  VISA
                </div>
                <div className="w-12 h-8 bg-gradient-to-br from-red-500 to-orange-500 rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-127">
                  MC
                </div>
                <div className="w-16 h-8 bg-blue-100 rounded flex items-center justify-center text-blue-900 text-xs font-bold italic" data-id="element-128">
                  PayPal
                </div>
                <div className="w-12 h-8 bg-blue-500 rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-129">
                  AMEX
                </div>
                <div className="w-16 h-8 bg-black rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-130">
                  Pay
                </div>
              </div>

              {/* Trust Box */}
              <div className="bg-green-50 rounded-xl p-6 mb-8" data-id="element-131">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-132">
                  <div className="flex flex-col items-center text-center" data-id="element-133">
                    <Lock className="w-8 h-8 text-green-600 mb-2" data-id="element-134" />
                    <h4 className="font-bold text-stone-900 text-sm" data-id="element-135">
                      Transacción 100% Segura
                    </h4>
                    <p className="text-xs text-stone-600" data-id="element-136">
                      Protegido con encriptación SSL de 256 bits
                    </p>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-137">
                    <ShieldCheck className="w-8 h-8 text-green-600 mb-2" data-id="element-138" />
                    <h4 className="font-bold text-stone-900 text-sm" data-id="element-139">
                      Garantía de 45 Días
                    </h4>
                    <p className="text-xs text-stone-600" data-id="element-140">
                      Satisfecho o te devolvemos el dinero
                    </p>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-141">
                    <CreditCard className="w-8 h-8 text-green-600 mb-2" data-id="element-142" />
                    <h4 className="font-bold text-stone-900 text-sm" data-id="element-143">
                      Pago Único
                    </h4>
                    <p className="text-xs text-stone-600" data-id="element-144">
                      Sin suscripciones. Sin costos ocultos
                    </p>
                  </div>
                </div>
              </div>

              {/* What happens next */}
              <div className="bg-[#FAF6F0] border border-stone-200 rounded-xl p-6" data-id="element-145">
                <h4 className="font-bold text-violet-900 mb-4 text-center" data-id="element-146">
                  ¿Qué pasa después de la compra?
                </h4>
                <div className="space-y-3" data-id="element-147">
                  <div className="flex gap-3" data-id="element-148">
                    <div className="w-6 h-6 rounded-full bg-violet-200 flex items-center justify-center text-sm font-bold text-violet-700 flex-shrink-0" data-id="element-149">
                      1
                    </div>
                    <p className="text-sm text-stone-700" data-id="element-150">
                      Completás tu pago de forma segura en la plataforma.
                    </p>
                  </div>
                  <div className="flex gap-3" data-id="element-151">
                    <div className="w-6 h-6 rounded-full bg-violet-200 flex items-center justify-center text-sm font-bold text-violet-700 flex-shrink-0" data-id="element-152">
                      2
                    </div>
                    <p className="text-sm text-stone-700" data-id="element-153">
                      Recibís un email inmediato con tus datos de acceso.
                    </p>
                  </div>
                  <div className="flex gap-3" data-id="element-154">
                    <div className="w-6 h-6 rounded-full bg-violet-200 flex items-center justify-center text-sm font-bold text-violet-700 flex-shrink-0" data-id="element-155">
                      3
                    </div>
                    <p className="text-sm text-stone-700" data-id="element-156">
                      Descargás el recetario y los bonos en tu dispositivo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 12. Testimonios reales */}
      <section className="py-20 px-4 bg-[#FAF6F0]" data-id="element-157">
        <div className="max-w-6xl mx-auto" data-id="element-158">
          <div className="text-center mb-12" data-id="element-159">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-160">
              <Star className="w-4 h-4 fill-current" data-id="element-161" />
              MENSAJES REALES DE ALUMNAS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-violet-900 mb-3" data-id="element-162">
              Lo que dicen quienes ya lo tienen
            </h2>
            <p className="text-stone-600 max-w-2xl mx-auto" data-id="element-163">
              Estos son mensajes reales que recibimos por WhatsApp e Instagram
              de mujeres que ya están haciendo y vendiendo sus budines.
            </p>
          </div>

          {/* WhatsApp screenshots */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 max-w-6xl mx-auto mb-16 [&>*]:mb-6" data-id="element-164">
            {[{
            img: 'https://cdn.magicpatterns.com/uploads/hiqL1Lxk5GuQBBFvYQU4rw/pasted-image.jpg',
            quote: '"Estoy probando las recetas y son un 10"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/m4ukshYJWHrUvfDATm6DB7/image.png',
            quote: '"Sos una re inspiración, el recetario me ayuda muchísimo"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/5jifRbT2XBVKUcjrrqpAdm/pasted-image.jpg',
            quote: '"Ya probé tres recetas y son una más rica que la otra"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/hNfyDXSN7x8ExTYdKcnrkX/pasted-image.jpg',
            quote: '"Sabor muy bueno, miga buena. ¡Me encantó el resultado!"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/tZKz1HvKNzjfhy1AjRDpnC/pasted-image.jpg',
            quote: '"Sumé los budines al catálogo y la gente está encantada"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/cqkv5Kr4Sadq3hXWK8C8cn/pasted-image.jpg',
            quote: '"Estaba esperando el recetario hace un montón"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/sCJPMcC4gw7eEVdCrFPZpy/pasted-image.jpg'
          }].map((item, i) => <div key={i} className="break-inside-avoid bg-white p-3 rounded-2xl shadow-lg border border-stone-100 hover:shadow-xl transition-shadow" data-id="element-165">
                <img src={item.img} alt={`Screenshot ${i + 1}`} className="w-full h-auto rounded-md mb-2" data-id="element-166" />
                {item.quote && <p className="text-sm text-gray-700" data-id="element-167">{item.quote}</p>}
              </div>)}
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 max-w-6xl mx-auto mb-16 [&>*]:mb-6" data-id="element-168">
            {[{
            img: 'https://cdn.magicpatterns.com/uploads/hiqL1Lxk5GuQBBFvYQU4rw/pasted-image.jpg',
            quote: '"Estoy probando las recetas y son un 10"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/m4ukshYJWHrUvfDATm6DB7/image.png',
            quote: '"Sos una re inspiración, el recetario me ayuda muchísimo"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/5jifRbT2XBVKUcjrrqpAdm/pasted-image.jpg',
            quote: '"Ya probé tres recetas y son una más rica que la otra"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/hNfyDXSN7x8ExTYdKcnrkX/pasted-image.jpg',
            quote: '"Sabor muy bueno, miga buena. ¡Me encantó el resultado!"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/tZKz1HvKNzjfhy1AjRDpnC/pasted-image.jpg',
            quote: '"Sumé los budines al catálogo y la gente está encantada"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/cqkv5Kr4Sadq3hXWK8C8cn/pasted-image.jpg',
            quote: '"Estaba esperando el recetario hace un montón"'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/sCJPMcC4gw7eEVdCrFPZpy/pasted-image.jpg',
            quote: '"Probé una de las recetas y quedó espectacular"'
          }].map((item, i) => <div key={i} className="break-inside-avoid bg-white p-3 rounded-2xl shadow-lg border border-stone-100 hover:shadow-xl transition-shadow" data-id="element-169">
                <img src={item.img} alt={`Mensaje real de clienta ${i + 1}`} className="w-full rounded-xl" loading="lazy" data-id="element-170" />
                <div className="flex items-center justify-between mt-3 px-2 pb-1" data-id="element-171">
                  <div className="flex gap-0.5" data-id="element-172">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-173" />)}
                  </div>
                  <span className="text-xs text-stone-500 font-medium" data-id="element-174">
                    ✓ Verificado
                  </span>
                </div>
                <p className="text-center text-sm text-stone-600 mt-2 mb-1 italic" data-id="element-175">
                  {item.quote}
                </p>
              </div>)}
          </div>

          <p className="text-center text-stone-500 text-sm italic mt-10" data-id="element-176">
            Capturas reales. Datos personales preservados por privacidad.
          </p>
        </div>
      </section>
    </>;
}